import { render, staticRenderFns } from "./faceUnlock.vue?vue&type=template&id=5475390c&scoped=true&"
import script from "./faceUnlock.vue?vue&type=script&lang=js&"
export * from "./faceUnlock.vue?vue&type=script&lang=js&"
import style0 from "./faceUnlock.vue?vue&type=style&index=0&id=5475390c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475390c",
  null
  
)

export default component.exports